<div
  class="loader position-{{ position }}"
  [style.width]="width"
  [style.height]="height"
  [style.fontSize]="thickness"
></div>
